import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import tweenState from 'react-tween-state';
import TooltipItem from './TooltipItem';

const StepProgressBar = React.createClass ({
    mixins: [tweenState.Mixin],

    getInitialState() {
        return {
            progress: this.getStepProgress(this.props.currentStep),
            currentStep: this.props.currentStep
        }
    },

    getStepProgress(step) {
        const steps = Object.keys(this.props.steps);

        if (steps.indexOf(step) === -1) {
            throw Error(`Invalid step: ${step}`);
        }

        return (steps.indexOf(step) / (steps.length - 1)) * 100;
    },

    onClickStep(step) {
        if (this.props.onClickStep) {
            this.props.onClickStep(step);
        }
    },

    componentWillReceiveProps(nextProps) {
        this.setState({
            currentStep: null
        });

        this.tweenState('progress', {
            easing: tweenState.easingTypes.easeInOutQuad,
            duration: 300,
            endValue: this.getStepProgress(nextProps.currentStep),
            onBegin: () => {
                this.setState({
                    currentStep: null
                })
            },
            onEnd: () => {
                this.setState({
                    currentStep: nextProps.currentStep
                })
            }
        });
    },

    renderProgressBar() {
        const style = {
            width: this.getTweeningValue('progress') + '%'
        };

        return <div className="step-progress-bar__progress" style={style} />;
    },

    renderProgressBarSteps() {
        const steps = Object.keys(this.props.steps);

        return steps.map((step, idx) => {
            const stepPosition = idx / (steps.length - 1) * 100;
            const stepStyle = { left: stepPosition + '%' };
            const isClickable = stepPosition < this.getTweeningValue('progress');
            const isFutureStep = stepPosition > this.getTweeningValue('progress');

            const classes = classNames('step-progress-bar__step', {
                'step-progress-bar__step--highlight': isClickable,
                'step-progress-bar__step--current': step === this.state.currentStep,
                'step-progress-bar__step--future': isFutureStep
            });

            return (
                <TooltipItem
                    key={step}
                    onClick={isClickable && this.onClickStep.bind(this, step)}
                    className={classes}
                    style={stepStyle}
                    tooltipVariations={isFutureStep ? ['disabled'] : []}
                    tooltip={this.props.steps[step]} />
            );
        });
    },

    render() {
        return (
            <div className="step-progress-bar">
                {this.renderProgressBar()}
                {this.renderProgressBarSteps()}
            </div>
        );
    }
});

StepProgressBar.propTypes = {
    steps: PropTypes.object.isRequired,
    currentStep: PropTypes.string.isRequired,
    onClickStep: PropTypes.func
};

export default StepProgressBar;



// WEBPACK FOOTER //
// ./js/launch/components/StepProgressBar.jsx